import * as actions from '../constants/PaymentPlanActionTypes';

export const setPaymentPlan = (payload) => ({ type: actions.SET_PAYMENT_PLAN, payload });
export const setOwing = (payload) => ({ type: actions.SET_OWING, payload });
export const setInstallments = (payload) => ({ type: actions.SET_INSTALLMENTS, payload });